import React from 'react'
import styled from 'styled-components'
import { FaLock } from 'react-icons/fa'
import { LucaIcon } from '@components'

interface Props {
  badge?: React.ReactNode
  children: React.ReactNode
}

export const LucaBrandHeading: React.FC<Props> = ({ children, badge }) => (
  <Wrap>
    <LucaIcon size={22} />
    <Text>{children}</Text>
    {badge}
  </Wrap>
)

export const LucaPrivateBadge: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Badge>
    <FaLock size={12} />
    <span>{children}</span>
  </Badge>
)

const Wrap = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.625rem;
  width: 100%;
  min-width: 0;
  color: ${({ theme }) => theme.luca.navy};

  svg:first-child {
    flex: 0 0 auto;
    color: ${({ theme }) => theme.luca.blue};
  }
`

const Text = styled.span`
  font-family: ${({ theme }) => theme.luca.fontDisplay} !important;
  font-weight: 600 !important;
  font-size: 1.625rem;
  line-height: 1.15;
  color: ${({ theme }) => theme.luca.navy};
`

const Badge = styled.span`
  flex: 0 0 auto;
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs}rem;
  padding: ${({ theme }) => theme.spacing.xxs}rem ${({ theme }) => theme.spacing.sm}rem;
  border-radius: ${({ theme }) => theme.borderRadius.lg}rem;
  background: ${({ theme }) => theme.luca.tint};
  color: ${({ theme }) => theme.luca.deepBlue};
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
  font-weight: 600;
  white-space: nowrap;
`
